import { Injectable, OnDestroy } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { ProductsResponse } from '../api/products.response.model';
import { ProductModel } from '../product.model';
import { Store } from '@ngrx/store';
import { phx } from "../../store/@types/models";
import Product = phx.portal.models.Product;
import { map, takeUntil } from 'rxjs/operators';
import { LOAD_PRODUCT } from "../../store/actions/product.actions";
import { ProductRequest } from '../api/product.request.model';

@Injectable({
  providedIn: 'root',
})
export class ProductService {


  constructor(public store: Store<{ product: Product }>) {
  }

  private ngUnsubscribe$ = new Subject<void>();

  public productDetail(pzn: string, idf: string) {
    this.store.dispatch(LOAD_PRODUCT({ payload:  {pzn, idf}  }));
    return this.store.select('product').pipe(takeUntil(this.ngUnsubscribe$), map((response: any) => {
      console.log(response);
      return new ProductModel(response);
    }))
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
